import axios from "axios";
import router from "../router";
import store from "./store";

const axiosInstance = axios.create();

axiosInstance.defaults.baseURL = process.env.API_URL || "https://ealing.secure-messaging.co.uk";
// axiosInstance.defaults.baseURL = process.env.API_URL || "https://preview.secure-messaging.co.uk";

axiosInstance.defaults.headers.post["Content-Type"] = "application/json";

axiosInstance.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem("token");

  config.headers.authorization = token ? token : "";

  return config;
});

// DCP pages that require the user to be logged in
const authRoutes = ["user_profile", "user_edit", "forgot_password", "chats", "posts", "events", "surveys"];

let isLoggingOut = false;

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const isLogoutRequest = error.config && error.config.method === "delete" && error.config.url === "/sessions";

    // if any request is 401 and the user token is set meaning they are logged in then we logout the user and reroute them
    // skip the logout request itself (it will 401 with an expired token) and any 401s that arrive while already logging out
    if (
      error.response &&
      error.response.status == 401 &&
      store.getters["user/isTokenSet"] &&
      !isLogoutRequest &&
      !isLoggingOut
    ) {
      isLoggingOut = true;

      store.dispatch("user/logoutUser").then(() => {
        isLoggingOut = false;

        // if user is on any of the DCP pages reroute them to the sign in page
        if (authRoutes.includes(router.currentRoute.name)) {
          router.push({ name: "sign_in" });
        }
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
